import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invoice-product-calculator".
// Pricing JSON lives in #invoice-product-pricing-data (see pages/invoices/shared/_product_pricing_json_script).
// Turbo-appended rows rely on delegation; new lines get rate/amount from the server.
export default class extends Controller {
  connect() {
    this.onInput = this.handleInput.bind(this)
    this.onChange = this.handleProductChange.bind(this)
    this.element.addEventListener("input", this.onInput)
    this.element.addEventListener("change", this.onChange)

    this.lineElements().forEach((line) => {
      this.applyProductPricing(line, { onlyIfRateBlank: true })
    })
  }

  disconnect() {
    this.element.removeEventListener("input", this.onInput)
    this.element.removeEventListener("change", this.onChange)
  }

  lineElements() {
    return this.element.querySelectorAll('[data-nested-line-list-target="line"]')
  }

  readPricing() {
    const el = document.getElementById("invoice-product-pricing-data")
    if (!el?.textContent?.trim()) return {}
    try {
      return JSON.parse(el.textContent)
    } catch {
      return {}
    }
  }

  handleInput(event) {
    const input = event.target
    const fieldName = input.name

    if (!fieldName || (!fieldName.includes("[qty]") && !fieldName.includes("[rate]"))) {
      return
    }

    const line = input.closest('[data-nested-line-list-target="line"]')
    if (!line) return

    this.syncAmount(line)
  }

  handleProductChange(event) {
    const select = event.target
    if (!select.matches?.("select[name*='[product]']")) return

    const line = select.closest('[data-nested-line-list-target="line"]')
    if (!line) return

    this.applyProductPricing(line, { onlyIfRateBlank: false, productSelect: select })
  }

  applyProductPricing(line, options = {}) {
    const { onlyIfRateBlank = false, productSelect: selectOverride } = options

    if (line.hidden) return

    const select =
      selectOverride || line.querySelector("select[name*='[product]']")
    if (!select) return

    const qtyInput = line.querySelector('input[name*="[qty]"]')
    const rateInput = line.querySelector('input[name*="[rate]"]')
    const amountInput = line.querySelector('input[name*="[amount]"]')

    if (!qtyInput || !rateInput || !amountInput) return

    const pricing = this.readPricing()
    const rateFilled = rateInput.value.trim() !== ""
    if (onlyIfRateBlank && rateFilled) return

    const product = select.value

    if (Object.prototype.hasOwnProperty.call(pricing, product)) {
      const rate = pricing[product]
      rateInput.value =
        typeof rate === "number" ? rate.toFixed(2) : String(rate ?? "")
      this.syncAmount(line)
    } else {
      rateInput.value = ""
      amountInput.value = ""
    }
  }

  syncAmount(line) {
    const qtyInput = line.querySelector('input[name*="[qty]"]')
    const rateInput = line.querySelector('input[name*="[rate]"]')
    const amountInput = line.querySelector('input[name*="[amount]"]')

    if (!qtyInput || !rateInput || !amountInput) return

    const qty = parseFloat(qtyInput.value) || 0
    const rate = parseFloat(rateInput.value) || 0
    amountInput.value = (qty * rate).toFixed(2)
  }
}
